import axios from "axios";
import router from "@/router";

const baseDomain = process.env.VUE_APP_BASE_DOMAIN;
const baseURL = `${baseDomain}`;

const ajax = axios.create({
  baseURL,
});

ajax.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

ajax.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response: resp, config: originalRequest } = error;

    if (resp && resp.status === 401 && !originalRequest._retry) {
      const refreshToken = localStorage.getItem("refresh_token");

      if (!refreshToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        router.push("/login");
        return Promise.reject(error);
      }

      try {
        const { data } = await axios.post(
          `${baseURL}/api/v1/auth/refresh-token`,
          {
            refresh_token: refreshToken,
          }
        );

        const newToken = data.data.access_token;
        localStorage.setItem("token", newToken);

        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        originalRequest._retry = true;

        return ajax(originalRequest);
      } catch (err) {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        router.push("/login");
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default ajax;
